// source: messages/enums/task_status.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require("google-protobuf");
var goog = jspb;
var global = Function("return this")();

goog.exportSymbol("proto.TaskStatus", null, global);
/**
 * @enum {number}
 */
proto.TaskStatus = {
  SUCCESS: 0,
  FAILURE: 1,
  STARTED: 2,
  QUEUED: 3,
};

goog.object.extend(exports, proto);
